<template>
    <b-modal
        id="previewEssay"
        title="Prévia do Conteúdo"
        size="lg"
        hide-footer>

        <div v-if="essay">

            <div v-if="essay.content_type === 'IMG'" class="text-center">
                <img :src="essay.preview" class="img-thumbnail" />
            </div>

            <div v-if="essay.content_type === 'TEXT'">

                <textarea
                    id="area"
                    ref="area"
                    rows="30"
                    class="essay-textarea essay-notes"
                    v-html="essay.content_text"
                    :disabled="true"
                >
                </textarea>
            </div>

        </div>

    </b-modal>
</template>

<script>
export default {
    data() {
        return {
            essay: null
        }
    },
    created() {
        this.$root.$on('showPreviewEssay', (essay) => {
            this.essay = essay
            this.$bvModal.show('previewEssay')
        })
    }
}
</script>

<style scoped>

</style>
